import type { SchemaBuilderSelectProps } from "./schema-builder-select.type";

import { useTranslation } from "react-i18next";

import { SchemaBuilderFormList } from "../schema-builder-form-list";

import { SchemaBuilderSelectRow } from "./schema-builder-select-row";

import "./schema-builder-select.style.less";

export const SchemaBuilderSelect = ({
  name,
  initialValues,
}: SchemaBuilderSelectProps) => {
  const { t } = useTranslation();

  return (
    <SchemaBuilderFormList
      name={name}
      title={t("schema:select.title")}
      tooltip={t("schema:select.tooltip")}
      addText={t("schema:select.add")}
      className="schema-builder-select"
      renderField={(field, { index, fields, removeField }) => (
        <SchemaBuilderSelectRow
          field={field}
          index={index}
          key={`select-row-${field.key}`}
          formListName={name}
          fieldsLength={fields.length}
          initialValues={initialValues}
          onDeleteClick={() => removeField(field.name)}
        />
      )}
    />
  );
};
